import { PlaceholderScreen } from "@/shell/PlaceholderScreen";

export default function Orders() {
  return <PlaceholderScreen title="Orders" testID="placeholder-orders" />;
}
